/**
 * Vendor 별 brand 아이콘 (inline SVG, lucide 호환 — currentColor + size prop).
 *
 * OpenAI 의 6-petal flower, Anthropic 의 단순 별, Google 의 G, Ollama 의 라마.
 * 실제 공식 brand 자산은 라이선스 확인 후 교체 필요 — 본 SVG 는 식별 가능 단순화 버전.
 */

interface IconProps {
  size?: number;
  className?: string;
  'aria-hidden'?: boolean;
}

export function OpenAiIcon({ size = 16, ...rest }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path d="M22.28 9.84a5.97 5.97 0 0 0-.51-4.91 6.05 6.05 0 0 0-6.5-2.9A5.99 5.99 0 0 0 4.97 4.13a5.97 5.97 0 0 0-3.99 2.9 6.04 6.04 0 0 0 .74 7.07 5.97 5.97 0 0 0 .51 4.91 6.05 6.05 0 0 0 6.5 2.9 5.99 5.99 0 0 0 10.3-2.1 5.97 5.97 0 0 0 3.99-2.9 6.04 6.04 0 0 0-.74-7.07Zm-9.04 12.65a4.48 4.48 0 0 1-2.87-1.04l.14-.08 4.78-2.76a.78.78 0 0 0 .39-.68v-6.74l2.02 1.17a.07.07 0 0 1 .04.05v5.58a4.5 4.5 0 0 1-4.5 4.5ZM3.56 18.4a4.47 4.47 0 0 1-.53-3.01l.14.09 4.78 2.76a.78.78 0 0 0 .79 0l5.84-3.37v2.33a.07.07 0 0 1-.03.06l-4.83 2.79a4.5 4.5 0 0 1-6.16-1.65Zm-1.26-10.5a4.48 4.48 0 0 1 2.34-1.97v5.69a.78.78 0 0 0 .39.68l5.81 3.35-2.02 1.17a.07.07 0 0 1-.07 0L3.92 14a4.5 4.5 0 0 1-1.62-6.1Zm16.62 3.86-5.84-3.37 2.02-1.17a.07.07 0 0 1 .07 0L20.46 10a4.5 4.5 0 0 1-.68 8.12v-5.69a.78.78 0 0 0-.39-.68Zm2.01-3.02-.14-.09-4.78-2.76a.78.78 0 0 0-.79 0L9.38 9.27V6.93a.07.07 0 0 1 .03-.06l4.83-2.79a4.5 4.5 0 0 1 6.69 4.66Zm-12.66 4.16-2.02-1.17a.07.07 0 0 1-.04-.05V6.1a4.5 4.5 0 0 1 7.38-3.46l-.14.08-4.78 2.76a.78.78 0 0 0-.39.68v6.74Zm1.1-2.35L12 8.99l2.62 1.5v3l-2.62 1.5-2.62-1.5v-3Z" />
    </svg>
  );
}

export function AnthropicIcon({ size = 16, ...rest }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path d="M14.34 4h-3.18L5 20h3.36l1.18-3.27h6.06L16.78 20h3.36L14.34 4Zm-3.5 9.93L13 8.16l2.15 5.77h-4.31Z" />
    </svg>
  );
}

export function GoogleIcon({ size = 16, ...rest }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fill="#4285F4"
        d="M22.5 12.27c0-.79-.07-1.55-.2-2.27H12v4.3h5.9a5.05 5.05 0 0 1-2.19 3.31v2.75h3.54c2.07-1.9 3.26-4.7 3.26-8.09Z"
      />
      <path
        fill="#34A853"
        d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.54-2.75c-.98.66-2.23 1.05-3.74 1.05-2.87 0-5.3-1.94-6.16-4.54H2.18v2.84A11 11 0 0 0 12 23Z"
      />
      <path
        fill="#FBBC05"
        d="M5.84 14.1A6.6 6.6 0 0 1 5.5 12c0-.73.12-1.44.34-2.1V7.06H2.18a11 11 0 0 0 0 9.88l3.66-2.84Z"
      />
      <path
        fill="#EA4335"
        d="M12 5.38c1.62 0 3.07.56 4.21 1.65l3.15-3.15A11 11 0 0 0 12 1 11 11 0 0 0 2.18 7.06l3.66 2.84C6.7 7.32 9.13 5.38 12 5.38Z"
      />
    </svg>
  );
}

export function OllamaIcon({ size = 16, ...rest }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path d="M12 2a4 4 0 0 0-4 4v2h8V6a4 4 0 0 0-4-4Zm-5 7a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-6a3 3 0 0 0-3-3H7Zm2 4a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm6 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z" />
    </svg>
  );
}

/** vendor 문자열 → 아이콘 컴포넌트 매핑 */
export function ProviderIcon({ vendor, size = 16 }: { vendor: string; size?: number }) {
  const v = vendor.toLowerCase();
  if (v.includes('openai')) return <OpenAiIcon size={size} aria-hidden />;
  if (v.includes('anthropic')) return <AnthropicIcon size={size} aria-hidden />;
  if (v.includes('google')) return <GoogleIcon size={size} aria-hidden />;
  if (v.includes('ollama')) return <OllamaIcon size={size} aria-hidden />;
  // fallback — 일반 칩 (Cpu 같은 lucide 도 가능하지만 import 회피)
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <rect x="4" y="4" width="16" height="16" rx="3" />
    </svg>
  );
}
